import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { NGXLogger } from "ngx-logger";
import { Observable } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import {
  padlockTokenFeatureKey,
  PadlockTokenState,
} from "../padlock/state/padlock-token.reducer";

@Injectable({ providedIn: "root" })
export class AuthInterceptor implements HttpInterceptor {
  padlockTokenState$: Observable<PadlockTokenState> = this.store.select(
    padlockTokenFeatureKey,
  );

  constructor(
    private store: Store<any>,
    private logger: NGXLogger,
  ) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return this.padlockTokenState$.pipe(
      take(1),
      switchMap((state) => {
        const token = state?.token;

        if (!token || req.url.startsWith("../")) {
          return next.handle(req);
        }

        return next.handle(
          req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
        );
      }),
    );
  }
}
